import { ProductItem } from '@/lib/types/api';
import useTranslation from 'next-translate/useTranslation';
export function ProductExtraInfo({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  return (
    <div className='px-5'>
      <div className='mb-4 border-b-[1px] py-5 font-secondary text-xl font-normal uppercase text-brand-500' />
      <p className='h2 mb-4' data-testid='additional-info-title'>
        {t('products:DETAIL_PAGE_ADDITIONAL_INFORMATION_TITLE')}
      </p>
      <div
        className='extra-info'
        dangerouslySetInnerHTML={{ __html: product.extra_info }}
      />
    </div>
  );
}
